import React from 'react';

interface CommandColumnProps {
  command: string;
}

export default React.memo((props: CommandColumnProps) => {
  return <>{props.command}</>;
});
